/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Packaging_Log_Note_Not_ApprovedInputs */

const vi_error_packaging_log_note_not_approved = /** @type {(inputs: Error_Packaging_Log_Note_Not_ApprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phiếu nhập của mẻ này chưa được duyệt nên chưa in được tem lô. Đợi thủ kho duyệt phiếu rồi bấm in lại.`)
};

/**

* @param {Error_Packaging_Log_Note_Not_ApprovedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_packaging_log_note_not_approved = /** @type {((inputs?: Error_Packaging_Log_Note_Not_ApprovedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Packaging_Log_Note_Not_ApprovedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_packaging_log_note_not_approved(inputs)
});